import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roleDisplay'
})
export class RoleDisplayPipe implements PipeTransform {

  transform(roleStr: string): string {
    if (!roleStr) return '';

    return roleStr
      .split(',')
      .map(role => role.trim())
      .filter(role => role !== 'SRE Support' && role !== 'IT Admin')
      .map(role => {
        if (role === 'SRE Admin') return 'ISO Admin';
        if (role === 'Customer Team') return 'Customer Support';
        return role;
      })
      .join(', ');
  }

}
